import { Injectable, Inject } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { APIS } from 'app/common/constants';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpService } from '../services/http.service';
import { MsalService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, RedirectRequest, AuthError } from '@azure/msal-browser';
import { environment } from 'environments/environment';

@Injectable()
export class RouteResolver implements Resolve<any> {

  constructor(private httpService: HttpService,
              private router: Router,
              private authService: MsalService,
              @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration) { }

  resolve(): Observable<any> {

    this.authService.instance.setActiveAccount(this.authService.instance.getAllAccounts()[0]);

    return this.authService.acquireTokenSilent({scopes: ['User.Read']}).pipe(
      map((result: AuthenticationResult) => {
        this.httpService.postData(APIS.LOGIN_V2, { token: result.idToken, platform: 2, clientName:environment.clientName }).subscribe((res) => {
          if(!res?.user?.approved) {
            this.router.navigate(['/not-approved']);
          }
        });
      }),
      catchError((err) => {
        if (err instanceof AuthError && this.msalGuardConfig) {
          // fallback to interaction when silent call fails
          return this.authService.acquireTokenRedirect({scopes: ['User.Read']} as RedirectRequest);
        }
        return Observable.throw(err.json().error)
      })
    )
  }
}
